import styled from "@emotion/styled";
export const StyledCreditsSelect = styled.div`
  .credits-selection {
    width: 100%;
    z-index: 5;

    .credits-selection__control {
      min-height: 36px;
    }

    .credits-selection__single-value {
      max-width: calc(100% - 8px);
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;

      .credits-option-value {
        font-size: inherit;
        color: inherit;
        line-height: 22px;
        display: block;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }

  .credits-option {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
  }

  .credits-option-label {
    font-size: 14px;
    color: #323338;
  }

  .credits-selection__option--is-selected .credits-option-label {
    color: white;
  }

  .credits-option-price {
    color: #676879;
    font-size: 14px;
  }
`;
